import { DuplicateRecordsForId, FileHeader, HeaderMapping, PropertyConfig } from '@amzn/awscat-portfolio-assessment-types';

import { WIZARD_STEP_VALUES } from './resources';

/**
 * An object that specifies label and value for a resource type
 */
export interface ResourceType {
    value: string;
    label: string;
    allowDuplicates?: boolean;
    hasOptionalHeaders?: boolean;
    url: string;
}

/**
 * A map from ResourceType.value to the ResourceType object
 */
export interface ResourceTypesMap {
    [value: string]: ResourceType;
}

/**
 * An object that specifies label and value for a wizard step
 */
export interface WizardStep {
    value: WIZARD_STEP_VALUES;
    label: string;
    onNext?: () => Promise<void>;
    onPrev?: () => Promise<void>;
}

/**
 * A map from WizardStep.value to the WizardStep object
 */
export interface WizardStepsMap {
    [value: string]: WizardStep;
}

/**
 * An options object that customize step navigation
 */
export interface StepNagivationOptions {
    duplicateExist?: boolean;
}

/**
 * A Map object from property value to an object describing the property
 */
export type PropertiesConfigMap = Map<string, PropertyConfig>;

/**
 * The return type of updateIdMapping API
 */
export interface UpdateIdMappingResponse {
    fileHeaders: FileHeader[];
}

/**
 * Synchronous function to be invoked when header mapping changes
 */
export type OnChangeSync = (item: HeaderMapping, e: any) => void;

/**
 * Asynchronous function to be invoked when header mapping changes
 */
export type OnChangeAsync = (item: HeaderMapping, e: any) => Promise<void>;

/**
 * Synchronous function to be invoked when duplicate records change after HeaderMapping step
 * Ultimately used to determine whether to skip deduplicate step
 */
export type OnDuplicatesChange = (duplicateRecordsMap: DuplicateRecordsMap) => void;

/**
 * A map from an id to the duplicate records associated with that id
 * Contains all data required to display the duplicate step in wizard
 */
export interface DuplicateRecordsMap {
    [id: string]: DuplicateRecordsForId;
}

/**
 * A portfolio property and whether any duplicated records for the specific ID differ in that property
 */
export interface DuplicateProperty {
    property: string;
    diff: boolean;
}

export enum SHOW_MAPPED_STATUS {
    ALL = 'all',
    MAPPED = 'mapped',
    UNMAPPED = 'unmapped',
}
